import { TableCaptionVariantType } from './variants';
export const getTableCaptionStyles = (FOUNDATIONS, FONT) => {
    return {
        [TableCaptionVariantType.DEFAULT]: {
            container: {
                display: 'table-caption',
                padding: FOUNDATIONS.spacing_150,
                font_family: '"Outfit Font", sans-serif',
            },
        },
    };
};
//# sourceMappingURL=styles.js.map